import { useEffect, useState } from "react";
import { api } from "@/lib/config";
import TourCard from "@/components/TourCard";

const FILTERS = [
  { key: "all", label: "All Journeys" },
  { key: "safari", label: "Safari Tours" },
  { key: "beach", label: "Safari & Zanzibar" },
];

export default function ToursPage() {
  const [tours, setTours] = useState([]);
  const [filter, setFilter] = useState("all");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.get("/tours").then((r) => setTours(r.data.tours || [])).finally(() => setLoading(false));
  }, []);

  const filtered = filter === "all" ? tours : tours.filter((t) => t.category === filter);

  return (
    <div data-testid="tours-page" className="pt-36 md:pt-40 pb-24 bg-[#FAF6F0]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center max-w-3xl mx-auto">
          <p className="overline">our catalog</p>
          <h1 className="font-display text-5xl md:text-7xl italic font-light mt-4 leading-tight">Choose Your Adventure</h1>
          <p className="mt-6 text-[#23170E]/65 text-lg">
            From a three-day crater escape to ten days of bush and beach — every itinerary is fully
            customizable. Below are our most-loved starting points.
          </p>
        </div>

        {/* Filters */}
        <div className="mt-14 flex flex-wrap justify-center gap-3">
          {FILTERS.map((f) => (
            <button
              key={f.key}
              data-testid={`filter-${f.key}`}
              onClick={() => setFilter(f.key)}
              className={`btn-pill ${filter === f.key ? "btn-pill-primary" : "btn-pill-light"}`}
            >
              {f.label}
            </button>
          ))}
        </div>

        {loading ? (
          <div className="mt-16 text-center text-[#23170E]/55">Loading journeys…</div>
        ) : (
          <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {filtered.map((tour) => (
              <TourCard key={tour.id} tour={tour} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
